import Lecture from '../api/lecture';
import * as mutation from '../mutations/lecture';

const state = {
  curriculum_store_idx: 0,
  curriculum: [],
  channel: {
    idx: 0,
    title: '',
    subscribes: false,
  },
  lecture: {
    created_at: 0,
    updated_at: 0,
    idx: 0,
    title: '',
    guid: '', // s3 스토리지의 동영상 버킷 주소
    filename: '',
    thumbnail: null,
    story_note: '',
    view_cnt: 0,
    comment_cnt: 0,
    status: '',
    store_idx: 0,
    chapter_idx: 0,
    duration: 0, // 영상의 총 재생시간 (초)
    user_playtime: 0,  // "user_playtime": []
    policy: '',
  }
};

const getters = {
  channel: state => state.channel,
  curriculum_store_idx: state => state.curriculum_store_idx,
  curriculum: state => state.curriculum,
  lecture: state => state.lecture,
};

const actions = {
  selectCurriculum ({ commit }, idx) {
    return Lecture.getStoreIdxChapter(idx).then(response => {
      commit(mutation.SELECT_CURRICULUM, { idx, curriculum: response.data });
    }).catch(err => {
      console.error(err);
    });
  },
  selectLecture ({ commit }, { storeIdx, lectureIdx, policy }) {
    return Lecture.getStoreIdxChapterLectureIdx(storeIdx, lectureIdx).then(response => {
      commit(mutation.SELECT_LECTURE, { lecture: response.data, policy });
    }).catch(err => {
      console.error(err);
    });
  },
  updateSignedCookie (context, { storeIdx, lectureIdx, loginAt }) {
    return Lecture.postStoreIdxChapterLectureIdxSigned (storeIdx, lectureIdx, loginAt);
  },
  updatePlaytime (context, { storeIdx, lectureIdx, userPlaytime, lastViewedTime }) {
    // lastViewedTime: millisecond 단위
    return Lecture.postStoreIdxChapterLectureIdxPlaytime(storeIdx, lectureIdx, userPlaytime, lastViewedTime);
  }
};

const mutations = {
  [mutation.SELECT_CURRICULUM] (state, { idx, curriculum }) {
    state.curriculum_store_idx = idx;
    state.curriculum = curriculum;
  },
  [mutation.SELECT_LECTURE] (state, { lecture, policy }) {
    if (lecture.video_type === 'youtube' && lecture.guid) {
      lecture.thumbnailURL = `https://img.youtube.com/vi/${lecture.guid}/maxresdefault.jpg`;
    } else if (lecture.video_type === 'thumbnailOnly') {
      lecture.thumbnailURL = lecture.filename;
    } else {
      lecture.thumbnailURL = `/${lecture.guid}/thumbnails/${lecture.filename}_tumb.${lecture.thumbnail}?${policy}`;
      lecture.hlsSrc = `/${lecture.guid}/hls/${lecture.filename}.m3u8`;
      lecture.dashSrc = `/${lecture.guid}/dash/${lecture.filename}.mpd`;
      lecture.mp4Src = `/${lecture.guid}/mp4/${lecture.filename}_Mp4_Avc_Aac_16x9_1280x720p_24Hz_4.5Mbps_qvbr.mp4`;
    }
    state.lecture = lecture;
  },
  [mutation.TOGGLE_SUBSCRIPTION] (state, { idx, flag }) {
    if (state.channel.idx === idx) state.channel.subscribes = flag;
  },
  [mutation.COMPLETE_LECTURE] (state, { storeIdx, lectureIdx, flag }) {
    let target = null;
    if (state.curriculum_store_idx === storeIdx) {
      for (let chapter of state.curriculum) {
        target = chapter.lectures.find(el => {
          return el.idx === lectureIdx;
        });
        if (typeof target !== 'undefined') break;
      }
      target.complete = flag;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
